import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import DoneTwoToneIcon from "@mui/icons-material/DoneTwoTone";

const fadeIn = keyframes`
0%
{
    opacity: .7;
    transform: translateY(100px);
}

100%
{
    opacity: 1;
    transform: translateY(0);

}
`;
const Toast = styled.div`
    padding: 16px 10px;
    font-size: 16px;
    font-weight: 500;
    background-color: ${(props) =>
        (props.type === "success") && "#e6f9f7"};
    width: 80vw;
    animation: ${fadeIn} 1s;
    display: flex;
    align-items: center;
    gap: 10px;
    position: fixed;
    bottom: 0;
    z-index: 999;
    margin-bottom: 20px;
`;
const StyledDoneTwoToneIcon = styled(DoneTwoToneIcon)`
    width: 18px !important;
    color: #007e77;
`;
const Content = styled.p`
    color: #007e77;
`;
const Name = styled.span`
    color: #007e77;
    font-weight: 800;
`;

function ToastMessage({ name, type, showToast, setShowToast, text }) {
    useEffect(() => {
        const timer = setTimeout(() => {
            setShowToast(false);
        }, 5000);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    if (!showToast) {
        return null;
    }

    return (
        <Toast
            name={name}
            type={type}
            text={text}
        >
            {type === "success" && (
                <>
                    <StyledDoneTwoToneIcon />
                    <Content>
                        <Name>{name}</Name> {text}
                    </Content>
                </>
            )}
        </Toast>
    );
}

export default ToastMessage;
